/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetReadinessRequest {
    sessionId?: string;
}

export interface GetSnapshotRequest {
    sessionId?: string;
}

/**
 * MissionControlApi - interface
 * 
 * @export
 * @interface MissionControlApiInterface
 */
export interface MissionControlApiInterface {
    /**
     * Per-module entitlement and integration capability readiness for SOC, VIPR, inventory, MDM, and integrations.
     * @summary Module readiness
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionControlApiInterface
     */
    getReadinessRaw(requestParameters: GetReadinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Per-module entitlement and integration capability readiness for SOC, VIPR, inventory, MDM, and integrations.
     * Module readiness
     */
    getReadiness(requestParameters: GetReadinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Operational counts plus prioritized next actions for the Mission Control program management UI.
     * @summary Program snapshot and next actions
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionControlApiInterface
     */
    getSnapshotRaw(requestParameters: GetSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Operational counts plus prioritized next actions for the Mission Control program management UI.
     * Program snapshot and next actions
     */
    getSnapshot(requestParameters: GetSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class MissionControlApi extends runtime.BaseAPI implements MissionControlApiInterface {

    /**
     * Per-module entitlement and integration capability readiness for SOC, VIPR, inventory, MDM, and integrations.
     * Module readiness
     */
    async getReadinessRaw(requestParameters: GetReadinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mission-control/readiness`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Per-module entitlement and integration capability readiness for SOC, VIPR, inventory, MDM, and integrations.
     * Module readiness
     */
    async getReadiness(requestParameters: GetReadinessRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getReadinessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Operational counts plus prioritized next actions for the Mission Control program management UI.
     * Program snapshot and next actions
     */
    async getSnapshotRaw(requestParameters: GetSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mission-control/snapshot`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Operational counts plus prioritized next actions for the Mission Control program management UI.
     * Program snapshot and next actions
     */
    async getSnapshot(requestParameters: GetSnapshotRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSnapshotRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
